import { render, staticRenderFns } from "./CustomerPasswordSetup.vue?vue&type=template&id=290fcd4a&scoped=true"
import script from "./CustomerPasswordSetup.vue?vue&type=script&lang=js"
export * from "./CustomerPasswordSetup.vue?vue&type=script&lang=js"
import style0 from "./CustomerPasswordSetup.vue?vue&type=style&index=0&id=290fcd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290fcd4a",
  null
  
)

export default component.exports